module.exports = __webpack_public_path__ + "assets/img/slow_cook_active.d5c4987c.png";